<template>
  <div class="car-wrapper">
    <svg
      fill="none"
      height="286"
      width="170"
      xmlns="http://www.w3.org/2000/svg"
      :style="`transform: rotate(${rotateAngle}deg)`"
      @click="handleClick"
    >
      <g class="part" filter="url(#filter-1)" id="rear">
        <path class="shape" d="M21.361 263.174c-2.266 2.806-1.625 6.932 1.35 8.966a39.091 39.091 0 0 0 22.087 6.864h80.405a39.113 39.113 0 0 0 22.087-6.859c2.974-2.039 3.615-6.159 1.349-8.965l-58.87-72.899c-2.459-3.041-7.09-3.041-9.549 0l-58.859 72.893Z" fill="var(--v-blue-lighten-4)"/>
        <text class="label" x="84" y="266" text-anchor="middle" dominant-baseline="central" :transform="isRotated ? 'rotate(180, 84, 266)' : ''">REAR</text>
      </g>
      <g class="part" filter="url(#filter-2)" id="right">
        <path class="shape" d="M89 171.693v-60.382c0-2.935 2.727-5.311 6.084-5.311h63.832c3.362 0 6.084 2.381 6.084 5.311v60.378c0 2.935-2.727 5.311-6.084 5.311H95.084c-3.357.005-6.084-2.376-6.084-5.307Z" fill="var(--v-blue-lighten-4)"/>
        <text class="label" x="151" y="141" text-anchor="middle" dominant-baseline="central" :transform="isRotated ? 'rotate(180, 151, 141)' : ''">R</text>
      </g>
      <g class="part" filter="url(#filter-3)" id="left">
        <path class="shape" d="M5 171.693v-60.382C5 108.376 7.727 106 11.084 106h63.832c3.362 0 6.084 2.381 6.084 5.311v60.378c0 2.935-2.727 5.311-6.084 5.311H11.084C7.727 177.005 5 174.624 5 171.693Z" fill="var(--v-blue-lighten-4)"/>
        <text class="label" x="18" y="141" text-anchor="middle" dominant-baseline="central" :transform="isRotated ? 'rotate(180, 18, 141)' : ''">L</text>
      </g>
      <g class="part" filter="url(#filter-4)" id="front-left">
        <path class="shape" d="M11.218 101C7.782 101 5 98.234 5 94.828V43.686c0-5.6 1.193-11.065 3.452-16.074 1.89-4.186 7.59-4.878 10.494-1.315L71.605 90.94c3.288 4.04.396 10.055-4.836 10.055H11.22V101Z" fill="var(--v-blue-lighten-4)"/>
        <path class="label" d="m25.233 70.996-8.467.003a1 1 0 0 1-.858-1.514l4.23-7.056a1 1 0 0 1 1.715 0l4.237 7.052a1 1 0 0 1-.857 1.515Z" fill="var(--v-blue-lighten-1)"/>
      </g>
      <g class="part" filter="url(#filter-5)" id="rear-left">
        <path class="shape" d="M11.218 182C7.782 182 5 184.766 5 188.172v51.142a39.052 39.052 0 0 0 3.452 16.074c1.89 4.186 7.59 4.878 10.494 1.315l52.659-64.643c3.288-4.04.396-10.055-4.836-10.055H11.22V182Z" fill="var(--v-blue-lighten-4)"/>
        <path class="label" d="m16.767 212.004 8.467-.003a1 1 0 0 1 .858 1.514l-4.23 7.056a1 1 0 0 1-1.715.001l-4.237-7.053a1 1 0 0 1 .857-1.515Z" fill="var(--v-blue-lighten-1)"/>
      </g>
      <g class="part" filter="url(#filter-6)" id="front-right">
        <path class="shape" d="M158.782 101c3.436 0 6.218-2.766 6.218-6.172V43.686c0-5.6-1.193-11.065-3.452-16.074-1.89-4.186-7.591-4.878-10.494-1.315L98.395 90.94c-3.288 4.04-.396 10.055 4.835 10.055h55.552V101Z" fill="var(--v-blue-lighten-4)"/>
        <path class="label" d="m144.766 70.996 8.468.003a1 1 0 0 0 .858-1.514l-4.23-7.056a1 1 0 0 0-1.715 0l-4.237 7.052a1 1 0 0 0 .856 1.515Z" fill="var(--v-blue-lighten-1)"/>
      </g>
      <g class="part" filter="url(#filter-7)" id="rear-right">
        <path class="shape" d="M158.782 182c3.436 0 6.218 2.766 6.218 6.172v51.142a39.056 39.056 0 0 1-3.452 16.074c-1.89 4.186-7.591 4.878-10.494 1.315L98.395 192.06c-3.288-4.04-.396-10.055 4.835-10.055h55.552V182Z" fill="var(--v-blue-lighten-4)"/>
        <path class="label" d="m153.234 212.004-8.468-.003a1 1 0 0 0-.858 1.514l4.23 7.056a1 1 0 0 0 1.715.001l4.237-7.053a1 1 0 0 0-.856-1.515Z" fill="var(--v-blue-lighten-1)"/>
      </g>
      <g class="part" filter="url(#filter-8)" id="front">
        <path class="shape" d="M21.361 19.83c-2.266-2.806-1.625-6.932 1.35-8.966A39.09 39.09 0 0 1 44.797 4h80.405a39.113 39.113 0 0 1 22.087 6.859c2.974 2.039 3.615 6.16 1.349 8.965l-58.87 72.9c-2.459 3.04-7.09 3.04-9.549 0L21.361 19.828Z" fill="var(--v-blue-lighten-4)"/>
        <text class="label" x="84" y="16" text-anchor="middle" dominant-baseline="central" :transform="isRotated ? 'rotate(180, 84, 16)' : ''">FRONT</text>
      </g>
      <g clip-path="url(#i)">
        <path d="M129.33 193.473c0 18.608-4.669 14.049-5.491 20.436l-.015.141c-1.153 11.776-2.193 20.247-2.55 22.138-.47 2.522-2.058 3.953-7.306 4.752v1.316c0 1.06-.791 1.943-1.835 2.058-5.399.595-13.9.726-27.302.726-13.397 0-21.898-.131-27.296-.726a2.068 2.068 0 0 1-1.841-2.058v-1.316c-5.243-.799-6.83-2.23-7.301-4.752-.352-1.88-1.38-10.278-2.534-21.966h-.005c-.703-6.852-5.527-1.844-5.527-20.749 0-21.966 2.373-18.174 2.094-24.013-.476-9.171-.776-18.273-.776-26.572V92.59c0-2.313-1.887-3.54-1.887-20.571 0-17.03 8.945-33.925 45.073-33.925s45.079 16.895 45.079 33.925c0 17.03-1.888 18.258-1.888 20.571v50.298c0 8.372-.305 17.563-.796 26.812v.058c-.186 5.415 2.104 2.131 2.104 23.715Z" fill="#fff" stroke="var(--v-primary-base)" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M134.98 170.887v-.971l.005-.141c.528-9.97.792-19.015.792-26.885V92.947l.16-.632c.558-2.235 1.727-6.893 1.727-20.294 0-11.97-3.961-22.029-11.464-29.08-8.94-8.413-22.859-12.68-41.37-12.68-18.507 0-32.431 4.268-41.372 12.68C35.961 49.993 32 60.046 32 72.022c0 13.4 1.169 18.059 1.727 20.294l.16.632v49.943c0 7.828.264 16.874.781 26.89l.067 1.348-.377.783c-.957 3.489-1.79 8.022-1.79 21.564 0 11.975 1.785 16.691 4.665 20.42l.915 1.19.15 1.499c.17 1.745.352 3.442.517 5.076l.176 1.687.377 3.348c.6 5.374 1.122 9.468 1.402 10.946.827 4.445 3.159 7.39 7.347 9.265l1.158.517.791 1.008a9.736 9.736 0 0 0 6.624 3.671c5.848.648 14.747.773 28.14.773 13.397 0 22.29-.125 28.144-.773a9.728 9.728 0 0 0 6.623-3.676l.791-1.003 1.159-.517c4.183-1.875 6.515-4.81 7.347-9.249.461-2.46 1.479-11.134 2.472-21.088l.15-1.499.915-1.191c2.875-3.718 4.654-8.429 4.654-20.404 0-13.903-.884-18.31-1.877-21.867l-.228-.721Zm-5.651 22.588c0 18.607-4.669 14.048-5.492 20.435l-.015.141c-1.153 11.777-2.193 20.248-2.549 22.138-.471 2.523-2.058 3.954-7.307 4.753v1.316c0 1.06-.791 1.943-1.835 2.058-5.398.595-13.9.726-27.302.726-13.397 0-21.898-.131-27.296-.726a2.068 2.068 0 0 1-1.84-2.058v-1.316c-5.244-.799-6.831-2.23-7.302-4.753-.351-1.88-1.38-10.277-2.533-21.965h-.006c-.703-6.852-5.527-1.844-5.527-20.749 0-21.966 2.373-18.174 2.094-24.013-.476-9.171-.776-18.274-.776-26.572V92.592c0-2.314-1.887-3.54-1.887-20.571 0-17.03 8.946-33.926 45.073-33.926 36.128 0 45.079 16.895 45.079 33.926 0 17.03-1.888 18.257-1.888 20.571v50.298c0 8.371-.305 17.563-.796 26.812v.057c-.186 5.416 2.105 2.131 2.105 23.716Z" fill="#000" fill-opacity=".06"/>
        <path d="M122.378 99.332c-1.665-12.951-8.18-37.696-24.173-51.488m13.232 142.704c.93-11.484.946-12.482.946-33.648 0-5.985 1.768-25.789 2.627-30.411m6.742 40.422-6.194.533m-.078-5.64 6.334-.94m-11.489 67.631v12.043m-1.138-198.742c-1.628-.57-3.205 1.275-1.809 2.042M55.433 240.146c5.232.799 14.105.966 29.137.966 15.031 0 23.904-.172 29.137-.966M46.761 99.332c1.665-12.951 8.18-37.696 24.173-51.488M57.703 190.548c-.931-11.484-.947-12.482-.947-33.648 0-5.985-1.768-25.789-2.627-30.411m-6.742 40.422 6.194.533m.078-5.64-6.334-.94m53.341 30.985-.532 30.123m-10.202-29.586-.176 30.098m-10.548-30.098.175 30.176m-10.91-30.713.528 30.123m-10.187 6.523v12.043m1.551-195.927c-.196-.522-1.432-.647-5.729 1.525-8.092 4.09-10.419 9.197-10.419 12.362 0 3.165.812 4.596 1.283 3.326 3.909-10.408 14.586-22.388 39.07-23.62 24.483 1.237 35.161 13.212 39.07 23.62.475 1.27 1.282-.156 1.282-3.326s-2.327-8.278-10.419-12.362c-4.302-2.172-5.538-2.047-5.729-1.525m-48.822-2.815c1.629-.57 3.206 1.275 1.81 2.042m61.779 170.384c.704-6.852 5.528-1.844 5.528-20.744 0-21.971-2.373-18.18-2.094-24.018m-81.377 44.762c-.703-6.852-5.528-1.844-5.528-20.744 0-21.971 2.374-18.18 2.094-24.018m76.439 27.804c.187.852 1.402.799 1.521-.062 1.628-12.158 1.742-29.972 1.742-54.883 0-10.754.465-19.13.843-25.862.134-2.434.264-4.706.357-6.852-2.86 9.28-7.581 24.128-7.581 51.514-.005 18.869 1.924 30.641 3.118 36.145ZM99.306 80.087c4.897.413 10.161.993 14.178 1.489.414.052.755.35.869.752.605 2.146 1.132 4.24 1.572 6.23a105.67 105.67 0 0 1 1.081 5.5.518.518 0 0 1-.579.6c-4.08-.564-10.089-1.238-16.278-1.744a1.038 1.038 0 0 1-.946-.94l-1.008-10.748a1.034 1.034 0 0 1 1.111-1.139Zm5.119-33.34c0 .266-.213.48-.475.48a.478.478 0 0 1-.476-.48c0-.265.213-.48.476-.48.262 0 .475.215.475.48Zm3.16 191.007a.478.478 0 0 1-.476.481.478.478 0 0 1-.476-.481c0-.265.213-.48.476-.48s.476.215.476.48Zm-.006-16.106c0 .156-.196.282-.439.282s-.44-.126-.44-.282c0-.156.197-.282.44-.282s.439.126.439.282Zm-5.258 1.118c0 .155-.197.282-.44.282-.242 0-.439-.127-.439-.282 0-.156.197-.282.439-.282.243 0 .44.126.44.282Zm-5.254.558c0 .156-.196.282-.44.282-.242 0-.439-.126-.439-.282 0-.155.197-.282.44-.282s.44.127.44.282Zm-5.258.282c0 .156-.197.282-.44.282s-.44-.126-.44-.282c0-.155.197-.282.44-.282s.44.127.44.282Zm-5.259 0c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.155.197-.282.44-.282.242 0 .439.127.439.282Zm21.029-34.363c0 .155-.196.282-.439.282s-.44-.127-.44-.282c0-.156.197-.282.44-.282s.439.126.439.282Zm-5.258 1.117c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.156.197-.282.439-.282.243 0 .44.126.44.282Zm-5.254.559c0 .156-.196.282-.44.282-.242 0-.439-.126-.439-.282 0-.156.197-.282.44-.282s.44.126.44.282Zm-5.258.282c0 .156-.197.282-.44.282s-.44-.126-.44-.282c0-.156.197-.282.44-.282s.44.126.44.282Zm-5.259 0c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.156.197-.282.44-.282.242 0 .439.126.439.282Zm5.264-147.838c0 .265-.213.48-.476.48a.478.478 0 0 1-.476-.48c0-.265.213-.48.476-.48s.476.215.476.48ZM50.536 197.264c-.186.852-1.401.799-1.52-.062-1.63-12.158-1.743-29.972-1.743-54.883 0-10.754-.465-19.13-.843-25.862-.134-2.434-.263-4.706-.356-6.852 2.859 9.28 7.58 24.128 7.58 51.514.005 18.869-1.924 30.641-3.118 36.145ZM84.57 41.227s-13.915.272-19.84 3.953C44.936 60.09 44.89 94.09 44.89 103.49c0 9.401 1.349 20.436 1.349 38.83 0 76.974 1.484 80.243 38.33 80.243 36.847 0 38.331-3.269 38.331-80.243 0-18.394 1.35-29.429 1.35-38.83 0-9.4-.042-43.399-19.84-58.309-5.926-3.681-19.84-3.953-19.84-3.953Zm0 203.813c-13.398 0-21.904-.136-27.297-.732a2.067 2.067 0 0 1-1.84-2.057v-5.594c0-1.274.455-2.501 1.277-3.462l.64-.747a6.08 6.08 0 0 0 1.464-3.959l-1.111-37.946c6.892 1.259 17.399 1.906 26.867 1.906 9.467 0 19.974-.647 26.867-1.906l-1.112 37.946c0 1.452.517 2.857 1.463 3.959l.642.747a5.299 5.299 0 0 1 1.277 3.462v5.594c0 1.06-.797 1.942-1.841 2.057-5.393.601-13.899.732-27.296.732ZM54.135 126.484c7.642-2.763 20.833-3.713 30.435-3.713s22.792.95 30.435 3.713c.879-4.737 1.99-8.863 2.89-12.591.879-3.583 2.575-8.393 3.857-12.378 1.283-3.984.44-2.96-1.075-3.473-1.52-.511-22.358-3.269-36.107-3.269-13.75 0-34.593 2.758-36.108 3.27-1.515.511-2.357-.513-1.075 3.472 1.277 3.985 2.973 8.795 3.857 12.378.9 3.728 2.012 7.854 2.89 12.591Zm15.698-46.397c-4.897.413-10.16.993-14.178 1.489-.414.052-.755.35-.869.752a112.627 112.627 0 0 0-1.572 6.23 104.926 104.926 0 0 0-1.08 5.5.518.518 0 0 0 .579.6c4.08-.564 10.088-1.238 16.277-1.744.502-.042.9-.439.947-.94l1.008-10.748a1.034 1.034 0 0 0-1.112-1.139Zm14.737 11.03c3.133 0 6.69.141 10.326.376a.52.52 0 0 1 .486.523v1.566a.516.516 0 0 1-.549.523c-3.593-.23-7.125-.377-10.263-.377-3.139 0-6.665.147-10.26.377a.52.52 0 0 1-.552-.523v-1.566c0-.277.217-.507.486-.523 3.64-.235 7.192-.376 10.326-.376Zm-18.905-44.37c0 .266-.213.48-.475.48a.478.478 0 0 1-.476-.48c0-.265.213-.48.476-.48s.475.215.475.48Zm-3.159 191.007a.478.478 0 0 1-.476.481.478.478 0 0 1-.475-.481c0-.265.213-.48.475-.48.263 0 .476.215.476.48Zm-.067-16.106c0 .156-.197.282-.44.282-.242 0-.44-.126-.44-.282 0-.156.198-.282.44-.282.243 0 .44.126.44.282Zm5.259 1.118c0 .155-.197.282-.44.282s-.44-.127-.44-.282c0-.156.197-.282.44-.282s.44.126.44.282Zm5.253.558c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.155.197-.282.44-.282.242 0 .439.127.439.282Zm5.259.282c0 .156-.197.282-.44.282s-.44-.126-.44-.282c0-.155.197-.282.44-.282s.44.127.44.282Zm5.258 0c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.155.197-.282.44-.282s.44.127.44.282Zm-21.03-34.363c0 .155-.196.282-.439.282-.242 0-.44-.127-.44-.282 0-.156.198-.282.44-.282.243 0 .44.126.44.282Zm5.26 1.117c0 .156-.197.282-.44.282s-.44-.126-.44-.282c0-.156.197-.282.44-.282s.44.126.44.282Zm5.253.559c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.156.197-.282.44-.282.242 0 .439.126.439.282Zm5.259.282c0 .156-.197.282-.44.282s-.44-.126-.44-.282c0-.156.197-.282.44-.282s.44.126.44.282Zm5.258 0c0 .156-.197.282-.44.282-.242 0-.439-.126-.439-.282 0-.156.197-.282.44-.282s.44.126.44.282ZM78.277 43.363c0 .265-.213.48-.476.48a.478.478 0 0 1-.476-.48c0-.265.213-.48.476-.48s.476.215.476.48Z" stroke="var(--v-primary-base)" stroke-width=".5" stroke-miterlimit="10"/>
      </g>
      <g class="part" id="all">
        <rect class="shape" x="66" y="140" width="36" height="32" rx="6" fill="var(--v-blue-lighten-4)" />
        <text class="label" x="84" y="156" text-anchor="middle" dominant-baseline="central" :transform="isRotated ? 'rotate(180, 84, 156)' : ''">All</text>
      </g>
      <defs>
        <filter id="filter-1" x="15" y="184" width="140" height="101.004" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-2" x="84" y="102" width="86" height="81" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-3" x="0" y="102" width="86" height="81" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-4" x="0" y="20" width="78" height="87" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-5" x="0" y="178" width="78" height="87" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-6" x="92" y="20" width="78" height="87" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-7" x="92" y="178" width="78" height="87" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <filter id="filter-8" x="15" y="0" width="140" height="101.004" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.06 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.07 0"/>
          <feBlend in2="effect1_dropShadow_1561_51142" result="effect2_dropShadow_1561_51142"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation=".5"/>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.427451 0 0 0 0 0.819608 0 0 0 0.1 0"/>
          <feBlend in2="effect2_dropShadow_1561_51142" result="effect3_dropShadow_1561_51142"/>
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_1561_51142" result="shape"/>
        </filter>
        <clipPath id="i">
          <path fill="#fff" transform="translate(32 30)" d="M0 0h106v223H0z"/>
        </clipPath>
      </defs>
    </svg>
    <v-btn class="rotate-btn" small icon @click="handleRotate">
      <v-icon small>$vuetify.icons.rotate</v-icon>
    </v-btn>
    <toggle-buttons
      class="mt-4"
      :items="buttons"
      :value="selected"
      @change="handleOtherClick"
    />
  </div>
</template>

<script>
import ToggleButtons from './ToggleButtons'
const ids = ['rear', 'right', 'left', 'front-left', 'rear-left', 'front-right', 'rear-right', 'front']

export default {
  name: 'CarView',
  components: {
    ToggleButtons,
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      buttons: [
        {
          icon: '$vuetify.icons.car',
          label: 'Other',
          value: 'other',
        },
        {
          icon: '$vuetify.icons.car-danger',
          label: 'Damage',
          value: 'damage',
        },
      ],
      rotateAngle: 0,
    }
  },
  computed: {
    isRotated() {
      return this.rotateAngle % 360
    },
    isSelectedAllAngles() {
      return ids.every(el => this.selected.includes(el))
    },
  },
  watch: {
    selected(value) {
      this.setActiveParts(value)
    },
  },
  methods: {
    handleClick(e) {
      const value = e?.target?.parentNode?.id
      if (!value) {
        return
      }

      if (value === 'all') {
        const newSelected = this.isSelectedAllAngles
          ? this.selected.filter(el => !ids.includes(el))
          : [...new Set([...this.selected, ...ids])];
        this.$emit('changeView', newSelected, this.filter.filter_var)
        return
      }

      const newSelected = this.selected.includes(value)
        ? this.selected.filter(el => el !== value)
        : [...this.selected, value]
      this.$emit('changeView', newSelected, this.filter.filter_var)
    },
    handleOtherClick(newSelected) {
      this.$emit('changeView', newSelected, this.filter.filter_var)
    },
    handleRotate() {
      this.rotateAngle = this.rotateAngle + 180;
    },
    setActiveParts(sel) {
      const parts = this.$el.querySelectorAll('.part')
      Array.from(parts).forEach(el =>
        sel.includes(el.id) ? el.classList.add("active-part") : el.classList.remove("active-part"))

      const allAngles = this.$el.querySelector('#all')
      this.isSelectedAllAngles ? allAngles.classList.add("active-part") : allAngles.classList.remove("active-part")
    },
  },
  mounted() {
    this.setActiveParts(this.selected)
  }
}
</script>

<style lang="scss" scoped>
.car-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.part {
  cursor: pointer;

  .shape {
    transition: 0.3s;

    &:hover {
      opacity: 0.3;
    }
  }
}

.label {
  fill: var(--v-blue-lighten-1);
  font-size: 12px;
  font-weight: 500;
  transition: 0.3s;
}

.active-part {
  .shape {
    fill: var(--v-primary-base);
  }

  .label {
    fill: white;
  }
}

.rotate-btn {
  position: absolute;
  right: 0;
  top: 0;
}

svg {
  transition: 0.3s;
}
</style>
